<div class="detalhamento-despesa flex flex-col mt-15" [class.estilo-projecao]="estiloProjecao">
  <div class="flex justify-between items-center mb-4">
    <h1 class="text-heading-lg m-0"
        [ngClass]="estiloProjecao ? 'text-blue-600 font-bold' : 'titulo-cinza text-semibold'">
      Detalhamento da despesa necessária para financiar o CAQ
    </h1>
    <img *ngIf="downloadClick.observed" src="assets/icons/download.svg" alt="Download" class="download-icon w-4 h-4 me-6 cursor-pointer" (click)="downloadClick.emit()">
  </div>

  <div class="w-full overflow-x-auto bg-white rounded-lg shadow-sm border border-gray-200">
    <table class="tabela-detalhamento">
      <thead>
        <tr>
          <th class="p-4 px-7 text-center">Itens de despesa</th>
          <th class="p-4 px-7 text-center">Valor (R$)</th>
          <th class="p-4 px-7 text-center coluna-percentual">%</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let linha of linhas"
            class="border-bottom"
            [class.linha-total]="linha.isTotal">
          <td class="p-3 px-7 align-middle">
            <span class="block"
                  [class.text-bold]="linha.isTitulo"
                  [class.pl-8]="linha.nivelRecuo === 1">
              {{ linha.descricao }}
            </span>
          </td>
          <td class="p-3 px-7 text-end align-middle">
            <span [class.text-bold]="linha.isTitulo">{{ linha.valor | number:'1.0-0':'pt' }}</span>
          </td>
          <td class="p-3 px-7 align-middle">
            <div class="flex items-center justify-end gap-4">
              <div class="barra-progresso-container">
                <div class="barra-progresso-fill"
                     [style.width.%]="linha.percentual"
                     [class.bg-total]="linha.isTotal"
                     [class.bg-ceu]="!linha.isTotal"></div>
              </div>
              <span class="texto-porcentagem" [class.text-bold]="linha.isTitulo">{{ linha.percentual | number:'1.1-1':'pt' }}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
